export const VIEW_WIDTH = 1400;
export const VIEW_HEIGHT = 820;
export const BOARD_LEFT = 100;
export const BOARD_TOP = 132;
export const LANE_HEIGHT = 94;
export const LANE_GAP = 4;
export const BOARD_WORLD_WIDTH = 1200;

export const COLORS = {
  ink: 0x201a14,
  parchment: 0xf3e1b5,
  parchmentDark: 0xc7a76a,
  panel: 0x2f241b,
  panelLight: 0x4c3928,
  gold: 0xf4c65b,
  goldDark: 0x9c6426,
  own: 0x78b779,
  ownDark: 0x315f3c,
  enemy: 0xc87562,
  enemyDark: 0x713b35,
  laneA: 0x345b36,
  laneB: 0x2a4d31,
  neutral: 0xefe4c4,
  danger: 0xe86d5a,
  white: 0xffffff,
} as const;

export const TEXT_STYLE = {
  fontFamily: '"Trebuchet MS", "Segoe UI", sans-serif',
  fill: COLORS.parchment,
} as const;
